import { z } from "zod";

/**
 * Legacy/placeholder branding shape from the prototype.
 * SUPERSEDED in Wave 1c by the canonical TenantBrandingSchema in
 * branding.schema.ts. Kept here for back-compat with any phase-2
 * AI-config consumers; new code should import from branding.schema.
 */
export const LegacyTenantBrandingSchema = z.object({
  tenantId: z.string().uuid(),
  logoUrl: z.string().url().nullable().default(null),
  primaryColor: z.string().regex(/^#[0-9a-fA-F]{6}$/).default("#1890FF"),
  productName: z.string().max(100).default("ArgusAI"),
  loginText: z.string().max(500).nullable().default(null),
});
export type LegacyTenantBranding = z.infer<typeof LegacyTenantBrandingSchema>;

export const PlatformAdminRoleSchema = z.enum(["sysadmin", "support", "billing"]);
export type PlatformAdminRole = z.infer<typeof PlatformAdminRoleSchema>;

// A tenant user's role enum stood here (admin | power_user | member | viewer)
// and had ZERO consumers — a fourth vocabulary for a noun that already had
// three. Deleted in Foundations 1 / B1-T1: roles are rows in the one roles
// table now, addressed by key. Type source: schemas/roles.ts (RoleKeySchema,
// PlatformRoleKeySchema).

export const AIUserStatusSchema = z.enum(["active", "suspended", "pending", "deactivated"]);
export type AIUserStatus = z.infer<typeof AIUserStatusSchema>;

// Library LB3-T1 — the classification alphabet (sensitivity, export control)
// and the document ingestion status stood here as a second, unread copy
// (zero consumers; the status copy carried a `quarantined` value the
// `document_status` enum never had). Deleted: document.schema.ts declares
// SensitivitySchema, ExportControlSchema and DocumentStatusSchema once.

export const AgentStatusSchema = z.enum(["active", "inactive", "draft", "archived"]);
export type AgentStatus = z.infer<typeof AgentStatusSchema>;

export const ConversationStatusSchema = z.enum(["active", "archived"]);
export type ConversationStatus = z.infer<typeof ConversationStatusSchema>;

export const MessageRoleSchema = z.enum(["user", "assistant", "system", "tool"]);
export type MessageRole = z.infer<typeof MessageRoleSchema>;
